module.exports = __webpack_public_path__ + "img/ai.c2f29c4d.svg";